import { cn } from '~/utils';

export default function RegenerateIcon({ className = '', size = '1em' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      width={size}
      fill="none"
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('icon-gradient', className)}
    >
      <defs>
        <linearGradient id="gradient-fill" x1="0" y1="0" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#F214A1" />
          <stop offset="100%" stopColor="#BC0278" />
        </linearGradient>
      </defs>

      <path
        fill="url(#gradient-fill)"
        d="M3.07 10.876C3.623 6.436 7.41 3 12 3a9.15 9.15 0 0 1 6.012 2.254V4a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1H15a1 1 0 1 1 0-2h1.957A7.15 7.15 0 0 0 12 5a7 7 0 0 0-6.946 6.124 1 1 0 1 1-1.984-.248m16.992 1.132a1 1 0 0 1 .868 1.116C20.377 17.564 16.59 21 12 21a9.15 9.15 0 0 1-6-2.244V20a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H7.043A7.15 7.15 0 0 0 12 19a7 7 0 0 0 6.946-6.124 1 1 0 0 1 1.116-.868"
      ></path>
    </svg>
  );
}
